import '../../../App.css'
import './Betting.css';
import { useState, useEffect } from 'react';
import { Modal, Input, Table, } from 'antd';
import axios from 'axios';
import Appconfig from '../../../config/config'
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { TfiPencilAlt } from "react-icons/tfi";
import { useNavigate, } from "react-router-dom";


function Betting() {
    const navigate = useNavigate();

    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const [openNews, setOpenNews] = useState(false)
    const [button, setButton] = useState(false)


    const [eventTypes, setEventTypes] = useState([])
    const [formData, setFormData] = useState({
        domain_name: "",
        site_code: "",
    });
    const [id, setId] = useState('')

    const handleSetFormData = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };


    function getEventTypes() {
        var data = JSON.stringify({
            user_id: userInfo?._id,
        });

        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}betting/getEventTypes`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.result) {
                    setEventTypes(response.data.resultData)
                }
                else {
                    console.log(response)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const navigateToDetails = (event_type) => {
        navigate(`/betting/eventOpenBetting/${event_type}`);
    };


    const columns = [
        {
            title: 'S.N.',
            key: 'serial_number',
            width: 120,
            render: (_, record, index) => (
                <span className="betting-serial-number">
                    {index + 1}
                </span>
            ),
        },
        {
            title: 'Sport Name',
            key: 'sport_name',
            render: (_, record) => (
                <button
                    type="button"
                    className="betting-sport-link"
                    onClick={() =>
                        navigateToDetails(
                            record.event_type
                        )
                    }
                >
                    {record.name}
                </button>
            ),
        },
    ];

    useEffect(() => {
        getEventTypes();
    }, [])

    return (
        <>
            <NotificationContainer />

            <main className="betting-sports-page">
                <section className="betting-sports-card">
                    <div className="betting-sports-heading">
                        <div className="betting-heading-content">
                            <span className="betting-heading-icon">
                                ⚙
                            </span>

                            <div>
                                <h1>Betting Sports</h1>

                                <p>
                                    Select a sport to manage
                                    event betting settings
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="betting-sports-summary">
                        <div>
                            <span>Total Sports</span>

                            <strong>
                                {eventTypes.length}
                            </strong>
                        </div>

                        <div>
                            <span>Available</span>

                            <strong>
                                {eventTypes.length}
                            </strong>
                        </div>
                    </div>

                    <div className="betting-sports-table-wrapper">
                        <Table
                            rowKey={(record) =>
                                record?._id ||
                                record?.event_type
                            }
                            columns={columns}
                            dataSource={eventTypes}
                            pagination={false}
                            className="betting-sports-table"
                            locale={{
                                emptyText:
                                    "No betting sports found.",
                            }}
                            scroll={{
                                x: 600,
                            }}
                        />
                    </div>
                </section>
            </main>
        </>
    );
}


export default Betting;
